import { useQuery } from "@tanstack/react-query";

import { api, ApiError } from "./client";

export interface FieldItem {
  key: string;
  type: "string" | "int" | "float" | "bool" | "enum";
  name: string;
  description: string;
  required: boolean;
  options: string[] | null;
  /** Optional value -> human label map for enum pickers (Giftery's
   *  validationRule.list `{value, title}` pairs land here). */
  option_labels?: Record<string, string> | null;
  validationRule: string | null;
  min: number | null;
  max: number | null;
  step: number | null;
}

export interface ServiceItem {
  service_name: string;
  price: number;
  service_id: number;
  currency: string;
  in_stock: number;
}

export interface CategoryItem {
  category_name: string;
  category_id: number;
  image_url: string | null;
  services: ServiceItem[];
  fields: FieldItem[];
}

export interface StockResponse {
  categories: CategoryItem[];
}

export function useStock() {
  return useQuery<StockResponse, ApiError>({
    queryKey: ["stock"],
    queryFn: () => api.get<StockResponse>("/web/api/stock"),
    staleTime: 30_000,
  });
}
